export const DF_KEYWORD_CUSTOM_PAGE = '$customPage';
export const DF_KEYWORD_CUSTOM_INPUT = '$customInput';
export const DF_KEYWORD_CUSTOM_FIELD = '$customField';
export const DF_KEYWORD_CUSTOM_UI = '$customUI';
export const DF_KEYWORD_SECTIONS = '$sections';
export const DF_KEYWORD_SORT = '$sort';
export const DF_KEYWORD_TRANSFORM = '$transform';
